export const isMarketPlace = window.location.host.includes('upsuite.flexofficepro')
